import { render } from "./HR_InstallSalaries_Dialog.vue?vue&type=template&id=8a211e16&scoped=true"
import script from "./HR_InstallSalaries_Dialog.vue?vue&type=script&lang=js"
export * from "./HR_InstallSalaries_Dialog.vue?vue&type=script&lang=js"

import "./HR_InstallSalaries_Dialog.vue?vue&type=style&index=0&id=8a211e16&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a211e16"]])

export default __exports__